import { generateActions } from "helpers/generateActions";
export const GET_BOOKINGS = generateActions("GET_BOOKINGS");
export const GET_BOOKINGS_SUCCESS = "GET_BOOKINGS_SUCCESS";
export const API_ERROR = "API_ERROR";
